import React from 'react';
import {Grid, Typography} from "@mui/material";
import {useNavigate} from "react-router";
import {fixStringToHtml} from "../../../tools/helper";

const MyCard = ({title,content,navigateUrl=""}) => {
    const navigate = useNavigate()
    return (
        <Grid item
              sx={{width:"400px",height:"400px",p:4,textAlign: 'justify',border:"1px solid rgba(109,110,118,0.3)",cursor:"pointer",":hover": {
                    background: "#FFD050"}}} onClick={()=>navigate(navigateUrl)}>
            <Typography variant={"h4"} fontWeight={700} my={2}>
                {title}
            </Typography>
            <Typography  dangerouslySetInnerHTML={{
                __html: fixStringToHtml(content)
            }} sx={{color:"gray"}}/>
        </Grid>
    );
};

export default MyCard;